/*@flow*/
/** @jsx jsx */
import type { Element } from 'react';
import { Fragment } from 'react';
import { css, jsx } from '@emotion/core';
import { useState } from 'react';
import { Tooltip } from 'react-bootstrap';
import cx from 'classnames';
// import type { CreateAlertSubscription_createAlertSubscription } from './mutations/__generated__/CreateAlertSubscription';
// import type { DestroyAlertSubscription_destroyAlertSubscription } from './mutations/__generated__/DestroyAlertSubscription';
import OverlayTriggerWrapper from 'comps/OverlayTriggerWrapper';
import DestroyAlertSubscription from './mutations/DestroyAlertSubscription';
import CreateAlertSubscription from './mutations/CreateAlertSubscription';

type ModeT = 'READY' | 'LOADING' | 'ERROR';
// type ResponseT =
//   | CreateAlertSubscription_createAlertSubscription
//   | DestroyAlertSubscription_destroyAlertSubscription;
type PropsT = {
  label: string,
  value: any,
  id: ID,
  districtId: ID,
  checked: boolean,
  mode?: ModeT,
  action?: (any) => Promise<any>,
  errors?: string[],
  onChange?: (v: any) => any,
};

const Component = (props: PropsT): Element<string> => {
  // HACK: to test component with different modes, we pass mode
  // via props. Same deal with `errors`.
  const [mode, setMode] = useState<ModeT>(props.mode || 'READY');
  const [errors, setErrors] = useState(props.errors || []);
  const { label, value, checked, onChange, districtId, id } = props;

  const onClick = (e) => {
    e.preventDefault();

    if (mode === 'LOADING') return;

    setMode('LOADING');

    const payload = {
      id,
      alertName: value,
      districtId,
      checked,
    };

    const { commit } = payload.checked
      ? DestroyAlertSubscription
      : CreateAlertSubscription;
    const toggleAction = props.action || commit;

    toggleAction(payload)
      .then((res) => {
        if (!res) return;
        if (res.success) {
          onChange && onChange(value);
          setMode('READY');
        } else {
          setMode('ERROR');
          setErrors(res.errors);
        }
      })
      .catch(() => {
        setMode('ERROR');
        setErrors(['Server error']);
      });
  };

  return (
    <div
      className="alert-subscription-line"
      css={css(`
      display: grid;
      grid-template-columns: 20px 1fr 20px;
      user-select: none;
    `)}
    >
      <div
        className="action-toggle"
        css={css(`
          padding-right: 4px;
          text-align: center;
        `)}
      >
        {mode === 'READY' && (
          <input
            type="checkbox"
            checked={checked}
            // HACK: This callback work in browsers. But it's needed
            // because React expects controlled checkbox fields to have both
            // a `checked` and an `onChange` prop.
            onChange={(_) => {}}
            onClick={onClick}
          />
        )}
        {mode === 'LOADING' && (
          <i
            className="fa fa-sync fa-spin"
            style={{ fontSize: '10px', color: '#aaa' }}
          />
        )}
        {mode === 'ERROR' && (
          <Fragment>
            <OverlayTriggerWrapper
              placement="left"
              // HACK: Jest uses jsdom, which cannot handle overlays, yet.
              defaultShow={process.env.NODE_ENV !== 'test'}
              overlay={<Tooltip id="errors-tooltip">{errors}</Tooltip>}
            >
              <i
                className="fa fa-exclamation-triangle"
                style={{
                  fontSize: '10px',
                  color: '#c51c1c',
                  top: -1,
                  position: 'relative',
                }}
              />
            </OverlayTriggerWrapper>
          </Fragment>
        )}
      </div>
      <div>
        <a onClick={onClick}>{label}</a>
      </div>
      <div className="subscription-details text-center">
        {!checked && (
          <a>
            <i
              className={cx('fa', {
                'fa-cog': checked,
                'fa-info-circle': false,
              })}
            />
          </a>
        )}
      </div>
    </div>
  );
};
export default Component;
